<template>
  <!-- One choice out of a few, e.g. Off / Optional / Mandatory (US 9398) -->
  <span class="td-choice" role="radiogroup">
    <button v-for="choice in choices"
            :key="choice"
            type="button"
            role="radio"
            :class="{ 'is-on': value === choice, 'is-strong': value === choice && choice === 'Mandatory' }"
            :aria-checked="value === choice ? 'true' : 'false'"
            :disabled="disabled"
            :qid="qid ? qid + '-' + choice.toLowerCase() : null"
            @click="$emit('input', choice)"
    >
      {{ $t('task_dialog.choices.' + choice.toLowerCase()) }}
    </button>
  </span>
</template>

<script>
  export default {
    name: 'TaskChoice',
    props: {
      value: {
        type: String,
        default: null
      },
      choices: {
        type: Array,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      qid: {
        type: String,
        default: null
      }
    }
  }
</script>
